import React, { useEffect, useState } from 'react'

const CHECK_INTERVAL_MS = 5 * 60 * 1000
const APP_SCRIPT_SELECTOR = 'script[type="module"][src*="/build/assets/"]'

export const appScriptUrl = (document: Document, baseUrl: string) => {
    const src = document.querySelector<HTMLScriptElement>(APP_SCRIPT_SELECTOR)?.getAttribute('src')
    if (!src) {
        return null
    }

    try {
        return new URL(src, baseUrl).href
    } catch {
        return null
    }
}

export const UpdateAvailablePrompt = () => {
    const [updateAvailable, setUpdateAvailable] = useState(false)

    useEffect(() => {
        const pageUrl = window.location.href
        const loadedScriptUrl = appScriptUrl(document, pageUrl)
        if (!loadedScriptUrl) {
            return
        }

        let cancelled = false
        const checkForUpdate = async () => {
            try {
                const response = await fetch(window.location.href, {
                    cache: 'no-store',
                    credentials: 'same-origin',
                    headers: { Accept: 'text/html' },
                })
                if (!response.ok || cancelled) {
                    return
                }

                const latestScriptUrl = appScriptUrl(
                    new DOMParser().parseFromString(await response.text(), 'text/html'),
                    pageUrl,
                )
                if (latestScriptUrl && latestScriptUrl !== loadedScriptUrl) {
                    setUpdateAvailable(true)
                }
            } catch {
                // A failed check should not interrupt the current session.
            }
        }

        const interval = window.setInterval(checkForUpdate, CHECK_INTERVAL_MS)
        const checkWhenVisible = () => !document.hidden && checkForUpdate()
        document.addEventListener('visibilitychange', checkWhenVisible)

        return () => {
            cancelled = true
            window.clearInterval(interval)
            document.removeEventListener('visibilitychange', checkWhenVisible)
        }
    }, [])

    if (!updateAvailable) {
        return null
    }

    return (
        <div className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-center gap-3 bg-mjBlue-800 px-4 py-3 text-sm text-white shadow-lg">
            <span>A new version of Merch Jar is available.</span>
            <button
                type="button"
                className="rounded bg-white px-3 py-1 font-medium text-mjBlue-800"
                onClick={() => window.location.reload()}
            >
                Reload
            </button>
        </div>
    )
}
